// Single source of truth for building optimised book-cover image URLs.
//
// Covers are stored on Cloudinary (originals are 1-3 MB PNGs) and must NEVER be
// rendered at full size. Every cover is served through the backend proxy
// `/api/files/cover/{bookId}`, which injects a Cloudinary `f_auto,q_auto,w_<n>`
// transform (see backend serve_cover_by_book_id) before redirecting. Passing the
// width here is what triggers that transform.
//
// Sizes: list/table thumbnails = 80px, default = 300px, book detail page = 600px.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const COVER_WIDTH = { list: 80, default: 300, detail: 600 };

export function coverUrl(bookId, width = COVER_WIDTH.default, bust) {
  if (!bookId) return '';
  let url = `${BACKEND_URL}/api/files/cover/${bookId}?w=${width}`;
  if (bust !== undefined && bust !== null && bust !== '') {
    url += `&t=${bust}`;
  }
  return url;
}
